import { render, staticRenderFns } from "./ContratacaoDetalhesCardDadosCarga.vue?vue&type=template&id=00c080d5"
import script from "./ContratacaoDetalhesCardDadosCarga.vue?vue&type=script&lang=js"
export * from "./ContratacaoDetalhesCardDadosCarga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports